/** The element ID of an entry, for `#<n>` links and scrolling. */
export function entryAnchor(number: number): string {
  return `entry-${String(number)}`;
}
